// Live refresh for the command center: a timer that partially reloads the
// `activity` prop, pausing, and a 10h auto-stop. The server decides what the
// feed holds and which rows are new since the previous refresh (it is sent that
// refresh's server time); this only remembers the new-row flags until they are
// seen. This is the single place a push-triggered refresh would slot in later.
import { router } from '@inertiajs/svelte'
import { POLL_INTERVAL_MS, autoStopDue, shouldPoll } from '../../lib/moderation_live.js'

export const createModerationLive = () => {
  let newIds = $state.raw(new Set())
  let paused = $state(false)
  let idle = $state(false)
  let refreshing = $state(false)
  let lastUpdatedAt = $state(null)
  let engagedAtMs = Date.now()

  const ingest = (activity) => {
    if (!activity) return
    const fresh = activity.events.filter((event) => event.fresh).map((event) => event.id)
    if (fresh.length > 0) newIds = new Set([...newIds, ...fresh])
    lastUpdatedAt = activity.server_time
  }

  const reload = () => {
    if (refreshing) return
    refreshing = true
    router.reload({
      only: ['activity'],
      headers: lastUpdatedAt ? { 'X-Moderation-Since': lastUpdatedAt } : {},
      onFinish: () => (refreshing = false)
    })
  }

  const reengage = () => {
    idle = false
    engagedAtMs = Date.now()
  }

  const pollable = () => shouldPoll({ hidden: document.hidden, paused, idle })

  const start = () => {
    const tick = () => {
      if (!paused && !idle && autoStopDue(engagedAtMs)) idle = true
      if (pollable()) reload()
    }
    // Refreshes are skipped while the tab is hidden; catch up the moment it is back.
    const onVisibility = () => pollable() && reload()

    const timer = setInterval(tick, POLL_INTERVAL_MS)
    document.addEventListener('visibilitychange', onVisibility)
    return () => {
      clearInterval(timer)
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }

  return {
    get newIds() { return newIds },
    get paused() { return paused },
    get idle() { return idle },
    get refreshing() { return refreshing },
    get lastUpdatedAt() { return lastUpdatedAt },
    ingest,
    start,
    markSeen: () => newIds.size > 0 && (newIds = new Set()),
    togglePaused: () => {
      paused = !paused
      if (!paused) {
        reengage()
        reload()
      }
    },
    refresh: () => {
      if (idle && !paused) reengage()
      reload()
    }
  }
}
